import { useQuery } from "react-query";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { DataListSchema } from "./useGetAllDataList";

export const getOneDataListApiKey = "getOneDataList" as const;

type Options = {
    enabled?: boolean;
};
export const useGetOneDataList = (dataListId?: number, options?: Options) => {
    const { enabled = true } = options || {};

    const query = useQuery({
        queryKey: [getOneDataListApiKey, dataListId],
        queryFn: async () => {
            if (!dataListId) return;

            const url = `/api/data_lists/${dataListId}`;
            const response = await sureApiCall.get(url);
            return response;
        },
        select: (response) => {
            if (!response) return;

            const data = zodParseWithDetailedLog(response.data, DataListSchema, {
                operation: "GET",
                endpoint: "/data_lists/:id",
            });
            return data;
        },
        enabled: enabled && dataListId !== undefined && dataListId > 0,
        staleTime: 300000,
        cacheTime: 300000,
    });

    return {
        dataList: query.data,
        ...query,
    };
};
